import React from 'react'
import PropTypes from 'prop-types'

const Text = ({ children, style }) => (
  <p style={{ fontFamily: 'Inter-Regular', ...style }}>{children}</p>
)

Text.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  style: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.array]),
}

Text.defaultProps = {
  style: null,
}

export default Text
